import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetDisclosureListParams = Required<operations['DisclosureController_findAll']['parameters']>['query']
type GetDisclosureCategoriesParams = Required<operations['DisclosureController_findAllCategory']['parameters']>['query']

/**
 * 공시 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param categoryId 공시 카테고리 id
 * @returns ResListDisclosure
 */
export const getDisclosureList = async ({ size = 50, offset = 0, categoryId }: GetDisclosureListParams) => {
  return (
    await axios.get<components['schemas']['ResListDisclosure']>('/disclosure', { params: { size, offset, categoryId } })
  ).data
}

/**
 * 공시 카테고리 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @returns ResListDisclosureCategory
 */
export const getDisclosureCategories = async ({ size = 50, offset = 0 }: GetDisclosureCategoriesParams) => {
  return (
    await axios.get<components['schemas']['ResListDisclosureCategory']>('/disclosure/category', {
      params: { size, offset },
    })
  ).data
}

/**
 * 공시 상세 조회
 * @param disclosureId 공시 id
 * @returns DisclosureDto
 */
export const getDisclosureDetail = async (disclosureId: number) => {
  return (await axios.get<components['schemas']['DisclosureDto']>(`disclosure/${disclosureId}`)).data
}
